export default __webpack_public_path__ + "images/e3b64ea85bea3de277b29762a89e240f-inkvisitor-full.svg";